/**
 * Linked product color swatches (custom.color_group_identifier → Product Color Group).
 * Default card state uses the current product images; swatch hover/click swaps images/links.
 */
(function () {
  'use strict';

  function getProductLinks(productItem) {
    return Array.from(productItem.querySelectorAll('a[href*="/products"]'));
  }

  function getSwatchInputFromTarget(target, swatchList) {
    if (!target || !swatchList.contains(target)) return null;

    if (target.matches('.color-swatch__radio')) {
      return target;
    }

    var label = target.closest('.color-swatch__item');
    if (!label) return null;

    var input = label.previousElementSibling;
    if (input && input.matches('.color-swatch__radio')) {
      return input;
    }

    var labelFor = label.getAttribute('for');
    if (labelFor) {
      return document.getElementById(labelFor);
    }

    return null;
  }

  function updateQuickBuyLinks(productItem, productUrl) {
    var separator = productUrl.indexOf('?') >= 0 ? '&' : '?';

    productItem.querySelectorAll('quick-buy-popover').forEach(function (el) {
      el.setAttribute('href', productUrl + separator + 'view=quick-buy-popover');
    });

    productItem.querySelectorAll('quick-buy-drawer').forEach(function (el) {
      el.setAttribute('href', productUrl + separator + 'view=quick-buy-drawer');
    });
  }

  function updateWishlistButton(productItem, productUrl, productId, variantId) {
    var wishlistBtn = productItem.querySelector('.swym-add-to-wishlist-view-product');
    if (!wishlistBtn) return;

    wishlistBtn.setAttribute('data-product-url', window.location.origin + productUrl);
    wishlistBtn.setAttribute('data-product-id', productId);
    if (variantId) {
      wishlistBtn.setAttribute('data-variant-id', variantId);
    }
  }

  function getColorNameFromInput(input) {
    if (!input) return '';

    var colorName = input.getAttribute('data-color-name');
    if (colorName) return colorName;

    var swatch = input.closest('.color-swatch');
    if (swatch) {
      colorName = swatch.getAttribute('data-tooltip');
      if (colorName) return colorName;
    }

    var label = input.nextElementSibling;
    if (label) {
      colorName = label.getAttribute('aria-label') || label.getAttribute('title');
      if (colorName) return colorName;
    }

    return '';
  }

  function updateColorName(productItem, input) {
    var nameEl = productItem.querySelector('[data-color-variation-name]');
    if (!nameEl || !input) return;

    var colorName = getColorNameFromInput(input);
    if (!colorName) {
      colorName = nameEl.getAttribute('data-default-color-name') || '';
    }

    if (colorName) {
      nameEl.textContent = colorName;
      nameEl.removeAttribute('hidden');
    }
  }

  function updateSwatchTooltip(swatch, colorName) {
    if (!swatch || !colorName) return;
    swatch.setAttribute('data-tooltip', colorName);
    var label = swatch.querySelector('.color-swatch__item');
    if (label) {
      label.setAttribute('title', colorName);
      label.setAttribute('aria-label', colorName);
    }
  }

  function swapCardImages(productItem, primaryMediaId, secondaryMediaId) {
    var imageWrapper = productItem.querySelector('.product-item__image-wrapper');
    var primaryImages = productItem.querySelectorAll('.product-item__primary-image');
    var secondaryImages = productItem.querySelectorAll('.product-item__secondary-image');
    var activeSecondary = null;

    primaryImages.forEach(function (image) {
      if (image.getAttribute('data-media-id') === primaryMediaId) {
        image.removeAttribute('hidden');
        image.setAttribute('loading', 'eager');
      } else {
        image.setAttribute('hidden', '');
      }
    });

    secondaryImages.forEach(function (image) {
      if (secondaryMediaId && image.getAttribute('data-media-id') === secondaryMediaId) {
        image.removeAttribute('hidden');
        image.setAttribute('loading', 'eager');
        activeSecondary = image;
      } else {
        image.setAttribute('hidden', '');
      }
    });

    if (imageWrapper) {
      if (activeSecondary) {
        imageWrapper.classList.add('product-item__image-wrapper--multiple');
      } else {
        imageWrapper.classList.remove('product-item__image-wrapper--multiple');
      }
    }
  }

  function applySwatchSelection(productItem, input, options) {
    if (!input) return;

    options = options || {};

    var productUrl = input.getAttribute('data-product-url');
    var primaryMediaId = input.getAttribute('data-primary-media-id');
    var secondaryMediaId = input.getAttribute('data-secondary-media-id');
    var productId = input.getAttribute('data-linked-product-id');
    var variantId = input.getAttribute('data-variant-id');

    if (!options.previewOnly) {
      getProductLinks(productItem).forEach(function (link) {
        link.setAttribute('href', productUrl);
      });

      updateQuickBuyLinks(productItem, productUrl);
      updateWishlistButton(productItem, productUrl, productId, variantId);
    }

    updateColorName(productItem, input);
    swapCardImages(productItem, primaryMediaId, secondaryMediaId);
  }

  function initLinkedColorSwatches(swatchList) {
    var productItem = swatchList.closest('product-item');
    if (!productItem || productItem.hasAttribute('data-linked-colors-init')) return;

    productItem.setAttribute('data-linked-colors-init', '');

    swatchList.querySelectorAll('.color-swatch').forEach(function (swatch) {
      var input = swatch.querySelector('.color-swatch__radio');
      if (!input) return;
      updateSwatchTooltip(swatch, getColorNameFromInput(input));
    });

    swatchList.addEventListener(
      'change',
      function (event) {
        var input = getSwatchInputFromTarget(event.target, swatchList);
        if (!input) return;

        event.stopImmediatePropagation();
        applySwatchSelection(productItem, input);
      },
      true
    );

    swatchList.addEventListener(
      'click',
      function (event) {
        var input = getSwatchInputFromTarget(event.target, swatchList);
        if (!input) return;

        event.stopImmediatePropagation();

        if (input.checked) {
          applySwatchSelection(productItem, input);
        }
      },
      true
    );

    swatchList.addEventListener('mouseover', function (event) {
      var input = getSwatchInputFromTarget(event.target, swatchList);
      if (!input) return;

      applySwatchSelection(productItem, input, { previewOnly: true });
    });

    swatchList.addEventListener('mouseleave', function () {
      var checkedInput = swatchList.querySelector('.color-swatch__radio:checked');
      if (checkedInput) {
        applySwatchSelection(productItem, checkedInput);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-linked-color-swatches]').forEach(initLinkedColorSwatches);
  }

  var initScheduled = false;

  function scheduleInitAll() {
    if (initScheduled) {
      return;
    }

    initScheduled = true;

    requestAnimationFrame(function () {
      initScheduled = false;
      initAll();
    });
  }

  function nodeHasLinkedSwatches(node) {
    if (!node || node.nodeType !== 1) {
      return false;
    }

    if (node.matches && node.matches('[data-linked-color-swatches], [data-native-color-swatches], product-item.product-item--linked-colors')) {
      return true;
    }

    return !!(node.querySelector && node.querySelector('[data-linked-color-swatches], [data-native-color-swatches], product-item.product-item--linked-colors'));
  }

  function setupDynamicInit() {
    if (window.__linkedColorSwatchObserver) {
      return;
    }

    window.__linkedColorSwatchObserver = new MutationObserver(function (mutations) {
      var shouldInit = mutations.some(function (mutation) {
        for (var i = 0; i < mutation.addedNodes.length; i++) {
          if (nodeHasLinkedSwatches(mutation.addedNodes[i])) {
            return true;
          }
        }

        return false;
      });

      if (shouldInit) {
        scheduleInitAll();
      }
    });

    window.__linkedColorSwatchObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function onReady() {
    initAll();
    setupDynamicInit();
  }

  document.addEventListener('DOMContentLoaded', onReady);
  document.addEventListener('shopify:section:load', onReady);

  // Collection AJAX pagination / facet filtering replaces product markup after these events fire.
  document.addEventListener('pagination:page-changed', scheduleInitAll);
  document.addEventListener('facet:criteria-changed', scheduleInitAll);
})();
